const API_HOST = 'https://prom.wechatpay.com.hk';
/** 查询投放信息接口 */
export const QRY_DP_MSG = `${API_HOST}/api/dp/v1/query_dp_message?noreport=1`;
/** 指定投放计划获取投放内容接口 */
export const QRY_DP_MSG_BY_DPID = `${API_HOST}/api/dp/v1/query_dp_message_bydpid?noreport=1`;
/** 曝光上报接口 */
export const SUBMIT_CHECK_VALUE = `${API_HOST}/api/dp/v1/sumbit_check_value?noreport=1`;
/** 香港钱包appid */
export const WPHK_APPID = 11;
/** 香港钱包投放渠道：h5 */
export const WPHK_DP_CHANNEL_H5 = 1;

// axios相关配置：这里的配置跟baselib里的有出入，需要重新设置一下
export const requestConfigs = {
  headers: { 'Content-Type': 'application/json' },
  transformRequest: [
    data => JSON.stringify(data),
  ],
};

/** 默认请求参数 */
export const defaultParams = {
  /** appid 香港钱包 */
  appid: WPHK_APPID,
  /** 渠道 h5 */
  dpChannel: WPHK_DP_CHANNEL_H5,
};
